import { PageContainer } from '@/shared/ui/PageContainer';

export const SubscriptionsPage = () => {
  return (
    <PageContainer>
      <p>Subscriptions page!</p>
    </PageContainer>
  );
};
